import { useState, useCallback, useRef } from 'react'

export function ResizablePanels({ left, right, defaultWidth = 280, minWidth = 200, maxWidth = 500 }: {
  left: React.ReactNode
  right: React.ReactNode
  defaultWidth?: number
  minWidth?: number
  maxWidth?: number
}) {
  const [leftWidth, setLeftWidth] = useState(defaultWidth)
  const dragging = useRef(false)

  const onDragStart = useCallback((e: React.MouseEvent) => {
    e.preventDefault()
    dragging.current = true
    const startX = e.clientX
    const startW = leftWidth
    const onMove = (ev: MouseEvent) => {
      if (!dragging.current) return
      setLeftWidth(Math.max(minWidth, Math.min(maxWidth, startW + ev.clientX - startX)))
    }
    const onUp = () => { dragging.current = false; document.removeEventListener('mousemove', onMove); document.removeEventListener('mouseup', onUp) }
    document.addEventListener('mousemove', onMove)
    document.addEventListener('mouseup', onUp)
  }, [leftWidth, minWidth, maxWidth])

  return (
    <div className="flex h-full min-h-0">
      <div className="shrink-0 flex flex-col overflow-y-auto h-full" style={{ width: leftWidth }}>
        {left}
      </div>
      <div
        className="w-1.5 bg-border/50 hover:bg-primary/30 transition-colors cursor-col-resize shrink-0"
        onMouseDown={onDragStart}
      />
      <div className="flex-1 overflow-auto">
        {right}
      </div>
    </div>
  )
}
